import { Ring } from "./Ring";
import { Section, SectionHead, SigBar } from "./SectionPrimitives";
import { sc, scLabel } from "./reportUtils";

export default function RankingsSection({ signals, overall, proj30, proj90 }) {
  return (
    <Section id="signals">
      <SectionHead num="05" title="The 8 Ranking Signals Google Actually Measures" subtitle="Most businesses only think about reviews. Google measures 8 things — and most of them are invisible." />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: "0 32px" }}>
        {signals.map((s, i) => (
          <SigBar key={i} label={s.name} score={s.score} critical={s.score < 20}
            detail={s.key === "gps" ? "The #1 signal agencies miss. Without GPS engagement, competitors pass you in 45 days." : null} />
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 14, marginTop: 24, padding: "20px 0", borderTop: "1px solid #E5E7EB" }}>
        {[["Today", overall, sc(overall)], ["30 Days", proj30, "#2563EB"], ["90 Days", proj90, "#0D6E3F"]].map(([l, s, c]) => (
          <div key={l} style={{ textAlign: "center", padding: 16, background: "#F9FAFB", borderRadius: 10, border: "1px solid #E5E7EB" }}>
            <p style={{ fontSize: 12, fontWeight: 700, color: "#4B5563", marginBottom: 8, letterSpacing: ".04em" }}>{l.toUpperCase()}</p>
            <Ring score={s} size={72} stroke={6} color={c} />
            <p style={{ fontSize: 13, fontWeight: 700, color: c, marginTop: 8 }}>{scLabel(s)}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
